import React, { useState } from "react";
import './Components.css'
import { Trans } from "react-i18next";
import { Button, Card, Table } from "reactstrap";
import { formatDateName, convertUTCToLocal } from "services/util";
import NoteModal from "./NoteModal";
import { useOrganisationContext } from "hooks";
import { NotificationManager } from "react-notifications";

export const HistoryAndNotes = ({ historyItem, item, type, contentType, client, t, hideNoteBtn = false }) => {

  const { selectedOrganisation } = useOrganisationContext();
  
  const [historyNotes, setHistoryNotes] = useState(item?.history_notes || historyItem)

  const [isHistoryVisible, setHistoryVisibility] = useState()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({})
  
  const renderToggleIcon = () => (isHistoryVisible ? '▲' : '▼');

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const toggleHistoryVisibility = () => {
      setHistoryVisibility(!isHistoryVisible);
  };

  const handleDetailsClick = (item) => {
      setHistoryVisibility(item);
  };

  const onModalFormSubmit = (data) => {
    Object.assign(data, {
      content_type_name: contentType,
      object_id: item.id,
      connected_organisation: selectedOrganisation?.id
    })
    let result = null

    if (formData.id) {
      result = client.put(`history-notes/${formData.id}`, data)
    } else {
      result = client.post(`history-notes`, data)
    }

    result.then((res) => {
      NotificationManager.success(t("Note was saved successfully."));

      let newHistoryNotes = []

      if (!formData.id) {
        newHistoryNotes = [res.data, ...historyNotes]
      } else {
        newHistoryNotes = historyNotes.map((item) => item.id === formData.id ? res.data : item)
      }

      setHistoryNotes(newHistoryNotes)
      setFormData({})

      toggleModal();
    }).catch((error) => { 
      NotificationManager.error(t(error.response?.message || 'Something went wrong.'));
    })
  };

  if (!historyNotes) {
    return null
  }
  
  return (
    <div className="pt-3">
      <div>
          <span
          className="toggle-button"
          onClick={toggleHistoryVisibility}
          style={{
              cursor: 'pointer',
              alignItems: 'center',
              fontSize: '1.2em',
          }}
            >{isHistoryVisible ? t("Hide") : t("Show")} <Trans>History & Notes</Trans> <span style={{ marginRight: '5px', fontWeight: 'bold' }}>{renderToggleIcon()}</span>
          </span>
      </div>
    {isHistoryVisible && (
      <Card className="p-3 mt-3" >
        {/* <h3><Trans>{type || ""} History & Notes:</Trans></h3> */}
        {!hideNoteBtn && (
          <div className="d-flex justify-content-end">
            <Button color="success" onClick={() => setIsModalOpen(true)}><Trans>Add Note</Trans></Button>
          </div>
        )}
        <Table>
          <tbody>
            {historyNotes?.map((item, index) => (
              <tr key={index} onClick={() => handleDetailsClick(item)}>
                <td className={`text-left history-td-${index}`}>
                  
                  <p style={{ fontSize: "1.1em", cursor: "pointer" }}><strong>{item.action === 0 ? "Created" : "Updated"}</strong> By {item.actor_info ? item.actor_info?.full_name : "Auto Generation System"} on { formatDateName(item.timestamp) } at { convertUTCToLocal(item.timestamp) }</p>
                  {isHistoryVisible === item && (
                    <div>
                      <p style={{ fontStyle: "italic" }}> 
                        {!item.is_note && !item.additional_data?.note ? item.additional_data?.message : item.additional_data?.note}
                        {item.is_note && 
                          <i className="fas fa-edit ml-4" style={{ cursor: "pointer" }} onClick={() => { setIsModalOpen(true); setFormData({ id: item.id, note_content: item.additional_data?.note }) }} />
                        }
                      </p>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    )}
    <NoteModal 
      modal={isModalOpen}
      toggle={toggleModal}
      data={formData || {}}

      submitHandler={onModalFormSubmit}
    />

  </div>
)};

export default HistoryAndNotes;